<template>
    <div class="font_control">
    <img class="font_control_icon" @click="handleHide" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211220/3a41f0b88f13b0330e09ba4fea04ac77.png" />
    <span @click="handleHide">字号</span>
    <div class="font_handle" v-if="showFontSetting">
      <div
        v-for="(item, idx) in fontGroup"
        :key="item"
        :class="[fontIndex === idx ? 'active font_handle_item' : 'font_handle_item']"
        @click="chooseFont(idx)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>
<script>
import { font_group } from '@/utils/config';
export default {
  props: {
    fontIndex: {
      type: Number,
      default: 0
    },
    showFontSetting: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return{
      fontGroup: font_group
    }
  },
  methods: {
    handleHide() {
      this.$emit('changeSettingShow', !this.showFontSetting)
    },
    chooseFont(idx) {
      this.$emit('changefont', idx)
    }
  }
}
</script>
<style lang="scss" scoped>

.font_control{
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.font_control_icon{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.font_handle {
  position: absolute;
  right: 0;
  top: 25px;
  width: 93px;
  z-index: 9;
  height: 99rpx;
  background: #FFFFFF;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 14px;
  text-align: right;
  line-height: 36px;
  font-size: 24px;
}
.font_handle .font_handle_item:first-child {
  line-height: 22px;
  margin-bottom: 12px;
  font-size: 14px;
}
.font_handle_item {
  cursor: pointer;
}
.font_handle_item.active{
  color: #1890FF;
}
</style>


// WEBPACK FOOTER //
// src/components/common/fontsetting.vue